var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "plan-selection" },
      [
        _c(
          "el-row",
          { attrs: { type: "flex", justify: "center", align: "middle" } },
          [
            _c(
              "el-col",
              { attrs: { xs: 24, sm: 20, md: 16, lg: 12, xl: 10 } },
              [
                _c(
                  "el-card",
                  { staticClass: "selection-card" },
                  [
                    _c(
                      "el-row",
                      { attrs: { type: "flex", justify: "center" } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "step-indicator" }, [
                            _c("div", { staticClass: "step-text" }, [
                              _vm._v("STEP 1 OF 3")
                            ])
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("h1", { staticClass: "title" }, [
                            _vm._v("Choose your plan.")
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "features-container" },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            { staticClass: "features-list" },
                            [
                              _c(
                                "el-row",
                                { staticClass: "feature-item" },
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ]),
                                  _vm._v(" "),
                                  _c("el-col", { attrs: { span: 22 } }, [
                                    _c("div", { staticClass: "feature-text" }, [
                                      _c("span", [
                                        _vm._v("Unlock New Revenue Streams")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("and Market Access")])
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "feature-item" },
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ]),
                                  _vm._v(" "),
                                  _c("el-col", { attrs: { span: 22 } }, [
                                    _c("div", { staticClass: "feature-text" }, [
                                      _c("span", [
                                        _vm._v(
                                          "Exclusive Off-Market Opportunities"
                                        )
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "feature-item" },
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _c("i", { staticClass: "el-icon-check" })
                                  ]),
                                  _vm._v(" "),
                                  _c("el-col", { attrs: { span: 22 } }, [
                                    _c("div", { staticClass: "feature-text" }, [
                                      _c("span", [
                                        _vm._v("Collaborate in a Powerful")
                                      ]),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v("Professional Network")
                                      ])
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "next-button",
                                attrs: { type: "primary" },
                                on: { click: _vm.goNext }
                              },
                              [_vm._v("Next")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-796c73d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796c73d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/selectPackage/uConnectSelectPlanStep.vue
// module id = null
// module chunks = 